// @flow

import React, { useCallback } from 'react';
import Checkbox from 'material-ui/Checkbox';
import { useForm, Controller } from 'react-hook-form';
import { makeRequest } from '../../util/http-client';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setTokens } from '../../lib/LoginUtils';
import toast from 'react-hot-toast';
import { resolver } from './login-form.schema';

import './theme/login-form.module.css';

export const LoginForm = ({ form, onSubmit }) => {
	const {
		control,
		watch,
		formState: { isValid },
		handleSubmit,
	} = form;

	const forgotWatched = watch('forgot');

	return (
		<div className="login-form__backdrop">
			<div className="login-form__container">
				<h3 className="login-form__header">{forgotWatched ? 'Восстановление пароля' : 'Вход'}</h3>
				<div className="login-form__row">
					<Controller
						name="email"
						control={control}
						render={({ field: { onChange, value } }) => (
							<TextField
								value={value}
								hintText="Email"
								autoComplete="one-time-code"
								floatingLabelText="Email"
								fullWidth
								onChange={onChange}
							/>
						)}
					/>
				</div>
				<div className="login-form__row" style={{ display: forgotWatched ? 'none' : 'block' }}>
					<Controller
						name="password"
						control={control}
						render={({ field: { onChange, value } }) => (
							<TextField
								value={value}
								type="password"
								autoComplete="one-time-code"
								hintText="Пароль"
								floatingLabelText="Пароль"
								fullWidth
								onChange={onChange}
							/>
						)}
					/>
				</div>
				<div className="login-form__row">
					<Controller
						name="forgot"
						control={control}
						render={({ field: { onChange, value } }) => <Checkbox label="Я не помню пароль" onCheck={onChange} checked={value} />}
					/>
				</div>
				<div className="login-form__row">
					<RaisedButton label="ВОЙТИ" disabled={!isValid} primary onClick={handleSubmit(onSubmit)} />
				</div>
			</div>
		</div>
	);
};

export const LoginFormContainer = () => {
	const form = useForm({
		resolver,
		mode: 'onChange',
		defaultValues: {
			email: '',
			forgot: false,
			password: '',
		},
	});

	const handleSubmit = useCallback(async data => {
		try {
			if (data.forgot) {
				await makeRequest('password-reset', { email: data.email });
				toast.success('На указанный вами email отправленно письмо с инструкцией');
				form.reset();
			} else {
				const response = await makeRequest('login', data);
				setTokens(response);
				document.location.reload();
			}
		} catch (error) {
			toast.error('Во время выполнения действия, произошла ошибка');
		}
	}, []);

	return <LoginForm form={form} onSubmit={handleSubmit} />;
};



// WEBPACK FOOTER //
// src/components/login-form/login-form.jsx